export default "__VITE_ASSET__BSqcID_u__"